import React from "react";
import PricingTableLoader from "./PricingTableLoader";
import BannerLoader from "./BannerLoader";
import FeatureComparisonLoader from "./FeatureComparisonLoader";

export const PreviewLoader = (props) => (
  <div
    className="dn flex-ns w-100 flex-column mh3 center"
    style={{ maxWidth: 960 }}
  >
    <BannerLoader {...props} />
    <PricingTableLoader {...props} />
    <FeatureComparisonLoader {...props} />
  </div>
);

export default PreviewLoader;
